<template>
    <div>
        <div class="topbar">
            <h2 class="heading2 w-100 mb-3">Settings</h2>
        </div>
            
        <div class="tabs tabs-primary">
            <b-nav tabs>
                <b-nav-item v-if="arrayHelper.inArray($store.state.user.permissions, 'custom-fields-manage')" to="/settings/custom-fields" :active="$route.hash === '/settings' || $route.hash === '/settings'">
                  Profile Fields
                </b-nav-item>
                <b-nav-item v-if="arrayHelper.inArray($store.state.user.permissions, 'tracker-template-manage')" to="/settings/tracker-templates" :active="$route.hash === '/settings/tracker-templates'">
                  Tracker Templates
                </b-nav-item>
                <b-nav-item to="/settings/notifications" :active="$route.hash === '/settings/notifications'">
                  Notifications
                </b-nav-item>
                <b-nav-item v-if="arrayHelper.inArray($store.state.user.permissions, 'tags-manage')" to="/settings/my-tags" :active="$route.hash === '/settings/my-tags'">
                  My Tags
                </b-nav-item>
                <b-nav-item to="/settings/email-templates" :active="$route.hash === '/settings/email-templates'">
                  Customize Emails
                </b-nav-item>
            </b-nav>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        current: String
    }
}
</script>

<style scoped>

</style>